import React from "react";
import { Section } from "components/UI/JsonForm/JsonInputRenderer/types";
import { IGetApplicationFormInfoServiceRes } from "api/Rover/ApplicationForm/types";

export interface IApplicationFormStep {
  title: string;
  sections: Section[];
  component?: React.FC;
  isReview?: boolean;
}

export type TApplicationFormType = "CLIENT_APPLICATION" | "PARTNER_PROPOSAL";

export interface IApplicationDetails {
  applicationData: any;
  files?: any;
}

export enum EFormConfigType {
  TEMPLATE = "TEMPLATE",
  FREE = "FREE",
}

export interface IApplicationFormProps {
  formData: IGetApplicationFormInfoServiceRes;
}
